import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Instagram } from "lucide-react";
import SectionIntro from "./SectionIntro";

const INSTAGRAM_URL = "https://www.instagram.com/laurierroseourika";
const MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=31.300988,-7.724062";

const About = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-cream pt-32 md:pt-40 pb-24">
      <div className="max-w-5xl mx-auto px-5 md:px-10">
        <SectionIntro
          eyebrow={t("about.eyebrow")}
          title={t("about.title")}
          lead={t("about.lead")}
          className="mb-14 md:mb-16"
        />

        <motion.div
          className="overflow-hidden mb-16 md:mb-20 aspect-[16/9] bg-cream-dark"
          initial={{ opacity: 0, scale: 1.04 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <img
            src="/images/gallery/exterior33.jpg"
            alt="Laurier Rose villa in the Ourika Valley"
            className="w-full h-full object-cover"
            loading="lazy"
            decoding="async"
          />
        </motion.div>

        <div className="max-w-2xl mx-auto space-y-6 text-ink-soft font-light leading-relaxed text-base md:text-lg">
          <p>{t("about.story1")}</p>
          <p>{t("about.story2")}</p>
        </div>

        <div className="rule-gold mx-auto my-16 md:my-20" />

        <div className="text-center max-w-xl mx-auto">
          <h2 className="font-serif font-light text-3xl md:text-4xl text-ink">
            {t("about.connectTitle")}
          </h2>
          <p className="text-ink-soft font-light mt-4 mb-8">
            {t("about.connectLead")}
          </p>

          <div className="flex flex-col items-center gap-3 mb-10 text-ink-soft">
            <a href="tel:+212661919669" className="hover:text-brass transition-colors">
              +212 661-919669
            </a>
            <a
              href="mailto:laurierroseourika@gmail.com"
              className="hover:text-brass transition-colors break-all"
            >
              laurierroseourika@gmail.com
            </a>
            <a
              href={MAP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brass transition-colors"
            >
              77XG+WV7 Taljerft, Ourika 42452, Morocco
            </a>
          </div>

          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 border border-ink/25 text-ink hover:bg-ink hover:text-cream text-[12px] uppercase tracking-[0.22em] py-4 px-10 transition-all duration-300"
          >
            <Instagram className="w-4 h-4" />
            {t("about.instagram")}
          </a>
        </div>

        <div className="text-center mt-16 md:mt-20">
          <Link
            to="/booking"
            className="inline-flex items-center justify-center bg-ink hover:bg-brass text-cream text-[12px] uppercase tracking-[0.22em] py-4 px-12 transition-colors duration-300"
          >
            {t("overview.bookNow")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default About;
